var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1926,
    height: 40,
    viewBox: "0 0 1926 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3580_63419)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3580_63419",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1926,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1926,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3580_63419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1731.65 -31.8733C1846.05 78.1007 1919.16 230.697 1925.5 400.361V-280.002H1890.92C1857.83 -184.93 1802.69 -100.168 1731.65 -31.8733Z",
    fill: "url(#paint0_linear_3580_63419)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.5 -31.8733C783.437 -100.188 728.319 -184.93 695.225 -280.002H307.598C362.013 -186.555 393.222 -77.9048 393.222 38.0464C393.222 302.762 230.698 529.47 0.0195312 623.96V804.114H786.606C707.199 698.352 660.145 566.917 660.145 424.47C660.145 245.178 734.718 83.3156 854.5 -31.8533V-31.8733Z",
    fill: "url(#paint1_linear_3580_63419)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.203 38.0464C393.203 -77.9048 361.994 -186.535 307.578 -280.002H0V623.94C230.679 529.45 393.203 302.742 393.203 38.0263V38.0464Z",
    fill: "url(#paint2_linear_3580_63419)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1731.65 -31.8735C1617.88 77.4988 1463.34 144.731 1293.07 144.731C1122.81 144.731 968.265 77.4788 854.501 -31.8735C734.698 83.2954 660.146 245.158 660.146 424.45C660.146 566.876 707.2 698.312 786.607 804.094H1799.56C1874.47 704.329 1920.55 581.699 1925.52 448.559V400.381C1919.16 230.716 1846.05 78.1206 1731.67 -31.8535L1731.65 -31.8735Z",
    fill: "url(#paint3_linear_3580_63419)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.5 -31.8732C968.265 77.4992 1122.81 144.731 1293.07 144.731C1463.34 144.731 1617.88 77.4791 1731.64 -31.8732C1617.88 -141.246 1463.34 -208.478 1293.07 -208.478C1122.81 -208.478 968.265 -141.225 854.5 -31.8732Z",
    fill: "url(#paint4_linear_3580_63419)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3580_63419",
    x1: 1828.59,
    y1: 422.299,
    x2: 1925.04,
    y2: -421.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#00ADEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942708,
    stopColor: "#64BC55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3580_63419",
    x1: 885.16,
    y1: 144.996,
    x2: -429.013,
    y2: 450.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#00ADEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942708,
    stopColor: "#64BC55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3580_63419",
    x1: -171.805,
    y1: 490.62,
    x2: 619.914,
    y2: -7.72093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#00ADEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942708,
    stopColor: "#64BC55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3580_63419",
    x1: 1262.93,
    y1: 912.602,
    x2: 1262.93,
    y2: 28.4489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#00ADEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942708,
    stopColor: "#64BC55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3580_63419",
    x1: 1037.88,
    y1: 309.77,
    x2: 1664.82,
    y2: -309.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#00ADEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942708,
    stopColor: "#64BC55"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3580_63419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1926,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.1805dcedb7af1ebf01be39419d85ad39.svg";
export { ForwardRef as ReactComponent };